module.exports = __webpack_public_path__ + "static/media/default-localposts.1e10cc2f.jpg";